module.exports = new __parcel__URL__("arrow-right-circle.a621a6b2.svg").toString();